import { Spin } from "antd";
import { useTranslation } from "react-i18next";

/**
 * LoadMorePopup — the dropdown body of a paginated ("load more") AntD Select:
 * the Select's own `menu`, followed by a "Loading more…" row while the next
 * page is being fetched. Pass it through `popupRender`:
 *
 *   popupRender={(menu) => (
 *     <LoadMorePopup menu={menu} loadingMore={isFetchingNextPage} />
 *   )}
 *
 * @param {React.ReactNode} menu - The menu node AntD hands to `popupRender`
 * @param {boolean} loadingMore - True while the next page is loading
 * @param {React.ReactNode} header - Optional content rendered above the menu
 */
const LoadMorePopup = ({ menu, loadingMore = false, header = null }) => {
  const { t } = useTranslation();

  return (
    <>
      {header}
      {menu}
      {loadingMore && (
        <div
          role="status"
          className="flex items-center justify-center gap-2 py-2 text-secondary text-sm"
        >
          <Spin size="small" />
          <span>{t("loadingMore")}</span>
        </div>
      )}
    </>
  );
};

export default LoadMorePopup;
